import { limitsContainerPropTypes } from '../../model';
import { Line } from './line';

export const LimitsContainer = ({ limitsNamespace = '', lowerBand = '', middleBand = '', upperBand = '' }) => (
  <>
    <div className={`${limitsNamespace}__limit-lines`}>
      <Line className={`${limitsNamespace}__lower`} />
      {middleBand && <Line className={`${limitsNamespace}__middle`} />}
      <Line className={`${limitsNamespace}__upper`} />
    </div>
    <div className={`${limitsNamespace}__limit-values`}>
      <div className={`${limitsNamespace}__lower`}>{lowerBand}</div>
      {middleBand && <div className={`${limitsNamespace}__middle`}>{middleBand}</div>}
      <div className={`${limitsNamespace}__upper`}>{upperBand}</div>
    </div>
  </>
);

LimitsContainer.propTypes = limitsContainerPropTypes;
